import { InfoOutlined } from "@mui/icons-material";
import { Box, FormControlLabel, Switch, Tooltip } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

const SwitchInputComponent = ({ name, label, sx = {}, disabled = false }) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, onChange, value, ...field } }) => (
        <FormControlLabel
          disabled={disabled}
          sx={sx}
          {...field}
          control={
            <Switch
              checked={value}
              onChange={(evt) => onChange(evt.target.checked)}
            />
          }
          label={label}
        />
      )}
    />
  );
};

export const SwitchInput = ({ tooltipContent = undefined, ...props }) => {
  if (tooltipContent !== undefined) {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <SwitchInputComponent {...props} />
        <Tooltip title={tooltipContent}>
          <InfoOutlined />
        </Tooltip>
      </Box>
    );
  }
  return <SwitchInputComponent {...props} />;
};
